export const california = {
  "06000": "California",
  "06001": "Alameda County",
  "06003": "Alpine County",
  "06005": "Amador County",
  "06007": "Butte County",
  "06009": "Calaveras County",
  "06011": "Colusa County",
  "06013": "Contra Costa County",
  "06015": "Del Norte County",
  "06017": "El Dorado County",
  "06019": "Fresno County",
  "06021": "Glenn County",
  "06023": "Humboldt County",
  "06025": "Imperial County",
  "06027": "Inyo County",
  "06029": "Kern County",
  "06031": "Kings County",
  "06033": "Lake County",
  "06035": "Lassen County",
  "06037": "Los Angeles County",
  "06039": "Madera County",
  "06041": "Marin County",
  "06043": "Mariposa County",
  "06045": "Mendocino County",
  "06047": "Merced County",
  "06049": "Modoc County",
  "06051": "Mono County",
  "06053": "Monterey County",
  "06055": "Napa County",
  "06057": "Nevada County",
  "06059": "Orange County",
  "06061": "Placer County",
  "06063": "Plumas County",
  "06065": "Riverside County",
  "06067": "Sacramento County",
  "06069": "San Benito County",
  "06071": "San Bernardino County",
  "06073": "San Diego County",
  "06075": "San Francisco County",
  "06077": "San Joaquin County",
  "06079": "San Luis Obispo County",
  "06081": "San Mateo County",
  "06083": "Santa Barbara County",
  "06085": "Santa Clara County",
  "06087": "Santa Cruz County",
  "06089": "Shasta County",
  "06091": "Sierra County",
  "06093": "Siskiyou County",
  "06095": "Solano County",
  "06097": "Sonoma County",
  "06099": "Stanislaus County",
  "06101": "Sutter County",
  "06103": "Tehama County",
  "06105": "Trinity County",
  "06107": "Tulare County",
  "06109": "Tuolumne County",
  "06111": "Ventura County",
  "06113": "Yolo County",
  "06115": "Yuba County",
};
